<template>
  <div>
    <h6 class="p-text-bold">Tipo do arquivo</h6>  
    <div class="p-formgroup-inline">
        <div class="p-field-radiobutton">
            <RadioButton name="tipoArquivo" value="AFDT" v-model="tipoArquivo" />
            <label>AFDT</label>
        </div>
        <div class="p-field-radiobutton">
            <RadioButton name="tipoArquivo" value="ACJEF" v-model="tipoArquivo" />
            <label>ACJEF</label>
        </div>
        <div class="p-field-radiobutton">
            <RadioButton name="tipoArquivo" value="AEJ" v-model="tipoArquivo" />
            <label>AEJ</label>
        </div>
    </div>
    <h6 class="p-text-bold">Período</h6>  
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-3">
            <label>Dia início</label>
            <Calendar v-model="dataInicio" :showIcon="true" :touchUI="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>				
        </div>
        <div class="p-field p-col-12 p-md-3">
            <label>Dia final</label>
            <Calendar v-model="dataFinal" :showIcon="true" :touchUI="true" :manualInput="false" dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>	
        </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-6">
            <label>Empresa</label>
            <Dropdown v-model.number="idCnpjSelecionado" :options="cnpjs" optionLabel="cnpjNome" optionValue="id" placeholder="Selecione"/>
        </div>   
        <div class="p-field p-col-0">
            <label style="color:#ffffff">.</label>              
        </div>                     
    </div>
    <Button label="Gerar Arquivo" icon="pi pi-file" class="p-mt-3" @click="exportarArquivo"/>
  </div>
</template>

<script>
import DocumentoService from '@/service/DocumentoService';
import { exibirMensagem, localeCalendarBR, exibirMensagemSis, download } from '@/global';
import { mapGetters } from 'vuex';

export default {
    documentoService: null,
    data() {
        return {
            tipoArquivo: 'AFDT',
            idCnpjSelecionado: null,
            cnpjs: [],
            dataInicio: new Date(),
            dataFinal: new Date(),
            localeCalendarBR: localeCalendarBR,
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao','getCacheEmpresa']), 
        /**
         * 
         */
        listarCnpjs() {            
            // Cache dados
            let cacheEmpresa = this.getCacheEmpresa();
            this.cnpjs = cacheEmpresa.cnpjs;                 
            if(cacheEmpresa.idCnpjSelecionado) {
                this.idCnpjSelecionado = cacheEmpresa.idCnpjSelecionado;
            }
        },
        /**
         * 
         */
        exportarArquivo() {
            if(this.idCnpjSelecionado == null) {
                exibirMensagemSis(this, 'Selecione uma empresa', true);
                return;
            }           
            let cnpj = null;
            for(let i = 0; i < this.cnpjs.length; i++) {
                if(this.idCnpjSelecionado == this.cnpjs[i].id) {
                    cnpj = this.cnpjs[i];
                    break;
                }
            }
            let requisicao = {
                tipoArquivo: this.tipoArquivo,
                dataInicio: this.formatarData(this.dataInicio),
                dataFinal: this.formatarData(this.dataFinal),
                cnpj: {...cnpj},
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };     
            if(this.tipoArquivo == 'AEJ') {
                this.exportarArquivoFiscalAEJ(requisicao);
            } else {
                this.exportarArquivoFiscal(requisicao);
            }     
        },
        /**
         * AEJ
         */
         exportarArquivoFiscalAEJ(requisicao) {
            this.documentoService.exportarArquivoFiscalAEJ(requisicao)
            .then(resp => {     
                download(resp.data, resp.headers['ik-response']);
            })
            .catch(erro => { 
                if(erro.response.headers['ik-response']) {
                    erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                }
                exibirMensagem(this, erro);
            });  
        },
        /**
         * AFDT ou ACJEF
         */
        exportarArquivoFiscal(requisicao) {
            this.documentoService.exportarArquivoFiscal(requisicao)
            .then(resp => {                   
                download(resp.data, resp.headers['ik-response']);
            })
            .catch(erro => { 
                if(erro.response.headers['ik-response']) {
                    erro.response.data = JSON.parse(erro.response.headers['ik-response']);
                }
                exibirMensagem(this, erro)
            });  
        },
        /**
         * 
         * @param {*} data 
         */
        formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		}
    },
    created() {
        this.documentoService = new DocumentoService();
    },
    mounted() {
        this.listarCnpjs();
    }
}
</script>

<style>

</style>